import React from 'react';
import PropTypes from 'prop-types';
import toDangerousReactHtml from '../../helper/to_dangerous_react_html';
import Translation from '../translation/translation';

function TranslatedBadgeRectangle({ type, text, placeholder, color }) {
    const containerClassNames = [
        'product-badge',
        `product-badge--${type}`,
        `product-badge--${color}`,
    ].join(' ');

    return (
        <Translation
            tagName="div"
            translationKey={text}
            placeholder={placeholder}
            className={containerClassNames}
        />
    );
}

TranslatedBadgeRectangle.propTypes = {
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    placeholder: PropTypes.object,
};

TranslatedBadgeRectangle.defaultProps = {
    placeholder: {},
};

export { TranslatedBadgeRectangle };
